<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--mobile" style="position:relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="filters-container">
            <TableFilters v-model="filterOptions" style="margin-right: 45px" @click="refresh" />
            <DropdownColumns v-model="fields" class="customize" />
          </div>
          <!--
          <b-table
            id="devices-table"
            :busy.sync="isBusy"
            show-empty
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :hover="true"
            :striped="true"
            stacked="md"
            v-model="copy"
            :items="provider"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            @row-clicked="rowClicked"
            tbody-tr-class="tr-pointer"
            v-columns-resizable="{afterResize: columnsWidthChanged}"
          >
          -->
          <b-table
            id="devices-table"
            :busy.sync="isBusy"
            show-empty
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :hover="true"
            :striped="true"
            stacked="md"
            :items="provider"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            @row-clicked="rowClicked"
            tbody-tr-class="tr-pointer"
            v-columns-resizable="{afterResize: columnsWidthChanged}"
          >
            <template v-slot:empty="scope">
              <div class="text-center">{{ $t(scope.emptyText) }}</div>
            </template>

            <template v-slot:head(id)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(uuid)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(name)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(type)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(eshop_id)="data">{{ $t(data.label) }}</template>
            <template v-slot:head(etenant_id)="data">{{ $t(data.label) }}</template>

            <template v-slot:cell(etenant_id)="data">
              <span v-if="data.value.to">
                <router-link :to="`/tenants/${data.value.to}`">{{ data.value.name }}</router-link>
              </span>
              <span v-else>{{ data.value.name }}</span>
            </template>

            <template v-slot:cell(eshop_id)="data">
              <span v-if="data.value.to">
                <router-link :to="`/shops/${data.value.to}`">{{ data.value.name }}</router-link>
              </span>
              <span v-else>{{ data.value.name }}</span>
            </template>

            <!--
            <template v-slot:head(selected)>
              <label class="kt-checkbox kt-checkbox--single kt-checkbox--all kt-checkbox--solid">
                <input type="checkbox" @click.stop @change="selectAll" v-model="checkAll" />
                <span></span>
              </label>
            </template>
            <template v-slot:cell(selected)="data">
              <label class="kt-checkbox kt-checkbox--single kt-checkbox--all kt-checkbox--solid">
                <input type="checkbox" @click.stop :value="data.item.eid" v-model="selected" />
                <span></span>
              </label>
            </template>
            -->

          </b-table>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space:nowrap;" class="my-2">
                <!--
                <BulkActionSelect
                  v-model="bulkAction"
                  :options="bulkActionOptions"
                  variant="light"
                  class="mr-2"
                  size="sm"
                  v-if="selected.length"
                />
                <b-button
                  @click.stop="applySelected()"
                  size="sm"
                  class="mr-2 refresh"
                  variant="light"
                  v-if="selected.length"
                  :disabled="!bulkAction"
                >{{$t('Apply')}}</b-button>
                <span class="pagination-sep" v-if="selected.length"></span>
                -->
                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="light"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{(currentPage-1) * perPage + 1}}</span>
                    <span slot="end">{{currentPage * perPage}}</span>
                    <span slot="total">{{totalRows}}</span>
                  </i18n>
                </span>
                <b-button
                  size="sm"
                  @click.stop="$root.$emit('bv::refresh::table', 'devices-table')"
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import startCase from "@/shared/strings";
import { errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import TableFilters from "@/components/TableFilters";
// import BulkActionSelect from "@/components/BulkActionSelect";

export default {
  components: {
    PaginationSelect,
    DropdownColumns,
    TableFilters,
    // BulkActionSelect,
  },
  name: "Devices",
  mixins: [tableMixin],
  data: function() {
    return {
      tableName: "devices",

      /*
      bulkAction: null,
      bulkActionOptions: [
        { text: "Do something with device", field: "status", value: "abc" },
        { text: "Do something else", field: "status", value: "def" },
        { text: "Enable Test", field: "test", value: true },
        { text: "Disable Test", field: "test", value: false }
      ],
      */

      filterOptions: [
        {
          field: "tenant_id",
          multiple: true,
          placeholder: "Tenant",
          trackBy: "eid",
          label: "brand_name",
          translate: false,
          store: "tenants",
          hide_select: true,
          filterOptions: ["shop_id"],
          options: [],
          selected: [],
        },
        {
          field: "shop_id",
          multiple: true,
          placeholder: "Shop",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shops",
          hide_select: true,
          options: [],
          originalOptions: [],
          selected: [],
          filterOptionsBy: (data, field, fieldValue) => {
            const selected = fieldValue.map(elem => elem.eid);
            const orig = data.list[1].originalOptions;
            if (
              selected.length == 0 &&
              data.list[1].options.length != orig.length
            ) {
              data.list[1].options = orig;
            } else if (selected.length != 0) {
              data.list[1].options = orig.filter(item => {
                if (selected.indexOf(item.etenant_id) > -1) {
                  return true;
                }
                return false;
              });
            }
          },
        },
      ],

      isBusy: false,
      sortBy: "name",
      sortDesc: false,
      fields: [
        /*
        {
          key: "selected",
          selected: false,
          ignore: true,
          class: "mw-select",
          dpIgnore: true
        },
        */
        {
          key: "eid",
          label: "Id",
          sortable: false,
          class: "d-none",
          ignore: true
        },
        { key: "uuid", sortable: true, class: "" },
        { key: "name", sortable: true, class: "" },
        { key: "type", sortable: true, class: "" },
        {
          key: "eshop_id",
          label: "Shop",
          class: "",
          ignore: true
        },
        {
          key: "etenant_id",
          label: "Tenant",
          sortable: true,
          class: "",
          ignore: true
        },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      // selected: [],
      // copy: null,
      addLabel: "Add device"
    };
  },

  watch: {
    /*
    selected(val) {
      if (val.length != this.copy.length) {
        this.checkAll = false;
      }
    },
    */
  },

  methods: {

    refresh() {
      this.$root.$emit("bv::refresh::table", "devices-table");
    },

    /*
    selectAll() {
      this.selected = [];
      this.copy.forEach(item => {
        if (this.checkAll) {
          this.selected.push(item.eid);
        }
      });
    },

    applySelected() {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const bulkData = {
        field: this.bulkAction.field,
        value: this.bulkAction.value,
        ids: this.selected
      };

      this.$store.dispatch("device/bulkAction", bulkData).finally(() => {
        loading.close();
        this.allSelected = false;
        this.selected = [];
        this.refresh();
      });
    },
    */

    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        let sortBy = this.sortBy;
        if (sortBy == "etenant_id") sortBy = "tenant_id";
        if (sortBy == "eshop_id") sortBy = "shop_id";
        paginationData.sortBy = [sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach(item => {
        if (item.selected.length) {
          exactFields.push(item.field);
          if (item.trackBy) {
            const tmp = [];
            item.selected.forEach(el => {
              tmp.push(el[item.trackBy]);
            });
            exactValues.push(tmp);
          } else {
            exactValues.push(item.selected);
          }
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }

      const tenantByID = this.$store.getters["cache/tenantByID"];
      const shopByID = this.$store.getters["cache/shopByID"];

      const tenantIDs = {};
      const shopIDs = {};

      this.$store
        .dispatch("device/fetch", paginationData)
        .then(resp => {
          this.totalRows = resp.data.total;
          resp.data.rows.forEach((item, index) => {
            if (item.status) {
              if (item.status == "active") {
                resp.data.rows[index]["_cellVariants"] = {
                  status: "success"
                };
              } else if (item.status == "blocked") {
                resp.data.rows[index]["_cellVariants"] = {
                  status: "danger"
                };
              } else if (item.status == "inactive") {
                resp.data.rows[index]["_cellVariants"] = {
                  status: "info"
                };
              }
            }
            if (item.etenant_id) {
              tenantIDs[item.etenant_id] = true;
            }
            if (item.eshop_id) {
              shopIDs[item.eshop_id] = true;
            }
          });

          Promise.all([
            this.$store.dispatch("cacheOnDemand/fetch", {
              key: "tenants",
              ids: Object.keys(tenantIDs)
            }),
            this.$store.dispatch("cacheOnDemand/fetch", {
              key: "shops",
              ids: Object.keys(shopIDs)
            })
          ])
            .then(([tenantsData, shopsData]) => {
              resp.data.rows.forEach(item => {
                if (item.etenant_id) {
                  item.etenant_id = {
                    to: item.etenant_id,
                    name: tenantsData[item.etenant_id].brand_name
                  };
                }
                if (item.eshop_id) {
                  item.eshop_id = {
                    to: item.eshop_id,
                    name: shopsData[item.eshop_id].name
                  };
                }
              });
            })
            .catch(err => {
              this.$bvToast.toast(
                this.$t(err.message),
                errorConf(this.$t("Error"))
              );
            });
          callback(resp.data.rows);
        })
        .catch(err => {
          this.$bvToast.toast(
            this.$t(err.message),
            errorConf(this.$t("Error"))
          );
          this.totalRows = 0;
          callback([]);
        })
        .finally(() => {
          loading.close();
        });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    rowClicked(item, index, event) {
      this.$router.push("/devices/" + item.eid);
    },
    redirect() {
      this.$router.push("/devices/0");
    }
  }
};
</script>

<style lang="scss" scoped>
</style>


